import { render } from "./AboutCounter.vue?vue&type=template&id=3bf96036"
import script from "./AboutCounter.vue?vue&type=script&lang=js"
export * from "./AboutCounter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__